import { EmploymentProfile } from '../types/employment.model'

/**
 * Wire shapes for `/restaurants/{restaurantId}/employment-profiles`, mirrors
 * the OpenAPI schemas EmploymentProfileDto and UpsertEmploymentProfileDto in
 * src/api/core/api.json.
 *
 * The response is field-for-field the client model, so the DTO is an alias
 * rather than a copy: a second declaration would only be somewhere for the two
 * to drift apart.
 */
export type EmploymentProfileDto = EmploymentProfile

/**
 * The body of a PUT. `userId` travels in the path, not here.
 *
 * PUT is a FULL REPLACE: the backend assigns every field from the body, so an
 * omitted field is stored as null rather than left alone. Callers must send a
 * complete profile, see employmentMapper.toUpsertDto.
 */
export type UpsertEmploymentProfileDto = Omit<EmploymentProfile, 'userId'>

/**
 * Both numeric fields are rejected below 1 (400), so an empty or zeroed field
 * has to be omitted from the body, it can never be sent as 0.
 */
export const HOURLY_RATE_MINOR_UNITS_MIN = 1
export const WEEKLY_HOURS_LIMIT_MIN = 1

export enum EMPLOYMENT_QUERY {
  PROFILES = 'employmentProfiles'
}
